module.exports = __webpack_public_path__ + "static/media/dinero.4a0b0f9f.svg";